import Axios from "axios";
import api from "./api";
import store from "@/store"; // 导入你的 Vuex store
import LoadingController from './util/loadingController';
// ***************** @FIXME 指纹功能 *******************
import FingerprintJS from '@fingerprintjs/fingerprintjs'
const fpPromise = FingerprintJS.load()

;(async () => {
    // Get the visitor identifier when you need it.
    const fp = await fpPromise
    const result = await fp.get()
    //console.log('1', result.visitorId);
  })()
// ************************************

const instance = Axios.create({
    baseURL: api.baseUrl,
    timeout: 100000
});

// Header常量
const HEADER_TOKEN = 'token';
const HEADER_ADDR = 'address';
const HEADER_CHAIN = 'chain';
const HEADER_VERSION = 'x-client-version'; // 推荐使用 'x-' 前缀表示自定义头

// 默认post会显示loading，添加一个postNoLoading方法，不显示loading
instance.postNoLoading = function(url, data, config = {}) {
  return this.post(url, data, { ...config, __loading: false }) // 强制显示loading
}

instance.interceptors.request.use(config => {
    if (!(config.__loading === false)) {
        LoadingController.start();
    }
    // 获取 token 和其他状态数据，添加默认值
    const token = store.state.token || 'defaultToken'; 
    const address = store.state.address || 'defaultAddress';
    const chain = store.state.chain || 'defaultChain';

    // 设置请求头
    config.headers[HEADER_TOKEN] = token;
    config.headers[HEADER_ADDR] = address;
    config.headers[HEADER_CHAIN] = chain;
    
    // 添加前端版本号（从环境变量或静态配置中读取）
    config.headers[HEADER_VERSION] = process.env.VUE_APP_VERSION || '1.0.0'; 

    return config 
}, error => {
    LoadingController.stop();
    return Promise.reject(error);
});

// 如果需要，添加响应拦截器
instance.interceptors.response.use(response => {
    LoadingController.stop();
    // 对响应数据进行处理
    return response;
}, error => {
    // 处理响应错误
    LoadingController.forceStop();
    console.error("Response error:", error);
    return Promise.reject(error);
});

// 超时强制关闭保护
setTimeout(() => LoadingController.forceStop(), LoadingController.timeout)

export default instance;
